import { createApp } from 'vue'
import { createPinia } from 'pinia'
import naive from 'naive-ui'
import { initTheme } from '@/core/theme'
import { APP_TITLE } from '@/core/appVersion'
import App from './App.vue'
import router from './core/router'
import '@/assets/global.scss'
import '@/assets/mobile.scss'

document.title = APP_TITLE
initTheme()

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(naive)
app.mount('#app')
